const getFormattedPrice = price => {
	return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price);
};

const mathRound = (number, digits = 2) => {
	const num = new Intl.NumberFormat('en-EN', { minimumFractionDigits: digits, maximumFractionDigits: digits })
		.format(number)
		.replaceAll(',', '');

	return Number(num);
};

export { getFormattedPrice, mathRound };
